/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpSharedAffirm_viewer$ref = any;
export type PdpRespSidebarButtons_viewer$ref = any;
export type PdpRespSidebarButtons_viewer = {
    readonly " $fragmentRefs": PdpSharedAffirm_viewer$ref;
    readonly " $refType": PdpRespSidebarButtons_viewer$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSidebarButtons_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedAffirm_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '37ed8605ba8febade1ba10f6735a3b70';
export default node;
